import React from 'react'
import { getAgreemnet } from './functions'
import { useParams } from 'react-router-dom'
import { isNil } from 'lodash/fp'
import log from 'loglevel'

export const Agreement: React.FC = () => {
  const { id } = useParams()
  React.useEffect(() => {
    if (isNil(id)) return
    getAgreemnet(id)
      .then((data: any | undefined) => {
        if (!isNil(data)) {
          const binaryString = window.atob(data)
          const len = binaryString.length
          const bytes = new Uint8Array(len)
          for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i)
          }
          const blob = new Blob([bytes], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)
          window.open(url, '_self')
        }
      })
      .catch((error) => {
        log.error(error)
      })
  })
  return <></>
}
